<!-- 确认弹窗 -->
<template>
  <div class='modal-mask'
       v-if='isShow'
       @click="maskCloseBtn">
    <div class='modal-wrap'>
      <div class='modal-container'
           :style='{width: defaultWidth}'
           @click="closeContainerBtn">
        <h4 class='title'>{{modalTitle}}</h4>
        <p class='content'>{{modalContent}}</p>
        <div class='oper'>
          <a href='javascript:void(0)'
             @click="confirmCancel"
             class='cancel'>取消</a>
          <a href='javascript:void(0)'
             @click="confirmOk"
             class='ok'>确认</a>
        </div>
        <div class='modal-close'
             @click="maskCloseBtn">
          <img :src='modalClose' />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import modalClose from '@/assets/undergraduate/images/modal_close.png'
export default {
  name: '',
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    modalTitle: {
      type: String,
      default: ''
    },
    modalContent: {
      type: String,
      default: ''
    },
    defaultWidth: {
      type: String,
      default: '500px'
    },
    maskClose: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data () {
    return {
      modalClose
    }
  },
  computed: {},
  mounted () {
  },
  methods: {
    // 遮罩层点击关闭
    maskCloseBtn () {
      this.$emit('closeModal')
    },
    // 阻止冒泡
    closeContainerBtn (e) {
      e.stopPropagation()
      return false
    },
    // 确认弹窗的确认操作
    confirmOk () {
      this.$emit('confirmModalOk')
    },
    // 确认弹窗的取消操作
    confirmCancel () {
      this.maskCloseBtn()
    }
  }
}
</script>
<style lang='less' scoped>
img {
  display: block;
  border: none;
}
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(230, 234, 241, 0.7);
  z-index: 9999;
  .modal-wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    border-radius: 8px;
    box-shadow: 0 8px 16px 0 #e6eaf1;
    .modal-container {
      background: #fff;
      padding: 20px;
      position: relative;
      .title {
        padding-top: 20px;
        text-align: center;
        font-size: 20px;
        color: #6a7786;
        letter-spacing: 0;
      }
      .content {
        text-align: center;
        font-size: 14px;
        color: #323c47;
        letter-spacing: 0;
        padding: 40px 20px;
      }
      .oper {
        text-align: center;
        a {
          display: inline-block;
          font-size: 14px;
          margin: 20px;
          width: 96px;
          height: 32px;
          border-radius: 8px;
          line-height: 32px;
          text-align: center;
        }
        .cancel {
          border: 1px solid #b1bcc8;
          color: #b1bcc8;
        }
        .ok {
          background-image: linear-gradient(12deg, #4aa6ff 0%, #4980fd 100%);
          color: #fff;
        }
      }
      .modal-close {
        position: absolute;
        right: 10px;
        top: 10px;
        width: 36px;
        height: 36px;
        padding: 10px;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
